/**
 * Reviews link -> smooth-scroll to the Judge.me review widget.
 *
 * The widget is a Shopify app block with no stable id, so the reviews link's href anchor
 * (`#judgeme-reviews`) never matches an element. This resolves the target at click time
 * by the Judge.me widget class and scrolls to its section. The href stays as a no-JS
 * fallback; if the widget is absent, the click falls through to native behaviour.
 *
 * A plain enhancement (not a Custom Element wrapper): the reviews link must stay the
 * pdp-reviews block's root so the `.main-product__info > .product-info-line` direct-child
 * and adjacent-sibling spacing selectors keep matching. Loaded once by main-product.liquid.
 */
function scrollToReviews(event) {
  const link = event.currentTarget;
  const widget =
    document.querySelector('.jdgm-review-widget') || document.querySelector('.jdgm-widget');
  const href = link.getAttribute('href') || '';
  const anchorTarget = href.startsWith('#') && href.length > 1 ? document.querySelector(href) : null;
  const target = (widget && (widget.closest('.shopify-section') || widget)) || anchorTarget;

  if (!target) return; // nothing to scroll to -> let native href handle it
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

document.querySelectorAll('.product-info__reviews-link').forEach((link) => {
  if (link.dataset.reviewsScrollBound) return;
  link.dataset.reviewsScrollBound = 'true';
  link.addEventListener('click', scrollToReviews);
});
